import React from 'react';
import { BodyText, Card, CardsGrid } from '@placer-ui/components';
import { TitleModalHeader } from 'features/offline-reports/support-requests/components/support-requests-modals/components/title-modal-header/title-modal-header';
import { SupportRequestModalContent } from 'features/offline-reports/support-requests/components/support-requests-modals/components/location-modal-content/support-request-modal-content';
import styles from './requests-type-selection.module.scss';
import { requestsCardsConfig } from './consts';
import type { SupportRequestType } from 'features/offline-reports/support-requests/components/support-requests-modals/types';
import { useSendSupportSplunkEvent } from 'features/offline-reports/support-requests/hooks/use-send-support-splunk-event';
import { useOpenSupportRequest } from '../../../support-modal-manager';

export const RequestsTypeSelection = () => {
    const sendSplunkEvent = useSendSupportSplunkEvent();
    const { openSupportRequest } = useOpenSupportRequest();

    const handleCardClick = (type: SupportRequestType) => {
        sendSplunkEvent({
            action: 'button-click',
            value: type,
        });

        openSupportRequest({ flowType: type });
    };

    return (
        <>
            <TitleModalHeader
                title="Request Locations"
                subTitle="Select the location type you would like to request to add to the platform"
            />
            <SupportRequestModalContent
                testId="requests-type-selection"
                requestModalType="typeSelection"
                fullSize
            >
                <CardsGrid
                    gap={32}
                    cardsPerRow={2}
                    alignGrid="center"
                    cards={requestsCardsConfig().map((card) => ({
                        id: card.title,
                        onClick: () => handleCardClick(card.type),
                        title: card.title,
                        description: card.description,
                        testId: card.testId,
                        appendToParent: true,
                        HeroImage: <div className={styles.iconContainer}>{card.icon}</div>,
                        children: (
                            <>
                                <Card.Header headline={card.title} />
                                <Card.Content>
                                    <BodyText color="secondary">{card.description}</BodyText>
                                </Card.Content>
                            </>
                        ),
                    }))}
                    cardType="Card"
                />
            </SupportRequestModalContent>
        </>
    );
};
